import { post } from './request'

export function homeStats(data = {}) {
  const payload = {}
  const projectId = Number(data.project_id)
  if (projectId > 0) payload.project_id = projectId
  if (projectId > 0 && data.building_id != null && data.building_id !== '') {
    payload.building_id = Number(data.building_id)
  }
  if (projectId > 0 && data.floor_id != null && data.floor_id !== '') {
    payload.floor_id = Number(data.floor_id)
  }
  return post('/api/Home/Stats', payload)
}
